module.exports = __webpack_public_path__ + "static/media/Line 43.a4e94d3a.svg";